<template>
  <div>
    <div class="label-container">
      <div class="label">
        {{ $t('aiPredictionReport.factor') }}
      </div>

      <div class="current">
        {{ $t('aiPredictionReport.current') }}
      </div>

      <div class="danger" v-if="riskIndex === 0">
        {{ $t('aiPredictionReport.dangerous') }}
      </div>

      <div class="danger" v-else>
        {{ $t('aiPredictionReport.Recmd') }}
      </div>

      <div class="increase">
        {{ $t('aiPredictionReport.changeInRisk') }}
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
    props: {
        riskIndex: VueTypes.number.isRequired
    }
}
</script>

<style scoped>
.label-container{
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  padding-left: 20px;
  padding-right: 20px;
}
.label-container > .label {
  justify-self: start;
  align-self: center;
}
</style>